import axios from "axios";

// Centro Preferenze pubblico: nessun header X-Workspace né Bearer (il tenant è risolto dal token); cookie di sessione HttpOnly.
export const portalApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/p`, withCredentials: true });

export function portalError(e) {
  const d = e?.response?.data?.detail;
  if (d && typeof d === "object") return d.message || d.code || "Errore";
  if (typeof d === "string") return d;
  return e?.message || "Errore di rete";
}

export const isGone = (e) => e?.response?.status === 410;
